import { render } from "./page4.vue?vue&type=template&id=5f633fba&scoped=true"
import script from "./page4.vue?vue&type=script&lang=js"
export * from "./page4.vue?vue&type=script&lang=js"

import "./page4.vue?vue&type=style&index=0&id=5f633fba&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f633fba"]])

export default __exports__